import { IconTag as TablerIconTag } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconTag = /*#__PURE__*/ createOutlineIcon(TablerIconTag, 'IconTag');
